import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthInterceptor } from '@totvs-apps-components/auth';
import { AtsInterceptor } from '../root/interceptor/interceptor';

export const httpInterceptorProviders: unknown[] = [
  { provide: HTTP_INTERCEPTORS, useClass: AtsInterceptor, multi: true },
];

httpInterceptorProviders.push({
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
});

@NgModule({
  providers: [httpInterceptorProviders],
  declarations: [],
  imports: [],
})
export class CoreModule {}
